import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const ProductDetailPage = lazy(() => import('../pages/product/page'));
const WorkshopPage = lazy(() => import('../pages/workshop/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog-detail/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const MemberPage = lazy(() => import('../pages/member/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const AdminLayout = lazy(() => import('../pages/admin/layout'));
const TeacherLayout = lazy(() => import('../pages/teacher/layout'));
const AdminDashboard = lazy(() => import('../pages/admin/page'));
const AdminProducts = lazy(() => import('../pages/admin/products/page'));
const AdminCourses = lazy(() => import('../pages/admin/courses/page'));
const AdminBlogs = lazy(() => import('../pages/admin/blogs/page'));
const AdminOrders = lazy(() => import('../pages/admin/orders/page'));
const AdminBookings = lazy(() => import('../pages/admin/bookings/page'));
const AdminCalendar = lazy(() => import('../pages/admin/calendar/page'));
const AdminTeachers = lazy(() => import('../pages/admin/teachers/page'));
const AdminTeacherApplications = lazy(() => import('../pages/admin/teacher-applications/page'));
const AdminSettings = lazy(() => import('../pages/admin/settings/page'));
const AdminSecurity = lazy(() => import('../pages/admin/security/page'));
const TeacherDashboard = lazy(() => import('../pages/teacher/page'));
const TeacherCourses = lazy(() => import('../pages/teacher/courses/page'));
const TeacherBookings = lazy(() => import('../pages/teacher/bookings/page'));
const TeacherCalendar = lazy(() => import('../pages/teacher/calendar/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/shop',
    element: <ShopPage />
  },
  {
    path: '/product/:id',
    element: <ProductDetailPage />
  },
  {
    path: '/workshop',
    element: <WorkshopPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/blog/:id',
    element: <BlogDetailPage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/cart',
    element: <CartPage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/member',
    element: <MemberPage />
  },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      {
        index: true,
        element: <AdminDashboard />
      },
      {
        path: 'products',
        element: <AdminProducts />
      },
      {
        path: 'orders',
        element: <AdminOrders />
      },
      {
        path: 'courses',
        element: <AdminCourses />
      },
      {
        path: 'bookings',
        element: <AdminBookings />
      },
      {
        path: 'calendar',
        element: <AdminCalendar />
      },
      {
        path: 'teachers',
        element: <AdminTeachers />
      },
      {
        path: 'blogs',
        element: <AdminBlogs />
      },
      {
        path: 'teacher-applications',
        element: <AdminTeacherApplications />
      },
      {
        path: 'settings',
        element: <AdminSettings />
      },
      {
        path: 'security',
        element: <AdminSecurity />
      }
    ]
  },
  {
    path: '/teacher',
    element: <TeacherLayout />,
    children: [
      {
        index: true,
        element: <TeacherDashboard />
      },
      {
        path: 'courses',
        element: <TeacherCourses />
      },
      {
        path: 'bookings',
        element: <TeacherBookings />
      },
      {
        path: 'calendar',
        element: <TeacherCalendar />
      }
    ]
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;